export default {
  'pages.account.title': '账户信息',
  'pages.account.phone': '手机号码',
  'pages.account.email': '邮箱',
  'pages.account.companyName': '公司名称',
  'pages.account.signOut': '退出登录',
  'pages.account.signOut.success': '登出成功',
  'pages.account.signOut.fail': '登出失败，请重试',
};
